import React, { useEffect, useState, useCallback } from 'react';
import Sidebar from '../components/layout/Sidebar';
import { AUTH_STORAGE_KEY } from '../socket';
import MobileBottomNav from '../components/layout/MobileBottomNav';

const getToken = () => { try { return JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY))?.token || null; } catch { return null; } };
const authHeader = () => { const t = getToken(); return t ? { Authorization: 'Bearer ' + t } : {}; };

export default function CategoryMasterPage() {
  const [role, setRole] = useState(3);
  const [categories, setCategories] = useState([]);
    const [activeTab, setActiveTab] = useState("Overview");
  const [position, setPosition] = useState(1);
  const [editPosition, setEditPosition] = useState(1);
  const [loading, setLoading] = useState(false);
  const [newName, setNewName] = useState('');
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');
  const [uploading, setUploading] = useState(false);
  const [toast, setToast] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

 useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

useEffect(() => {
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      const user = parsed?.user || {};
      setRole(Number(user.role) || (user.isAdmin ? 2 : 3));
    } catch (err) {
      setRole(3);
    }
  }, []);

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/service-categories', { headers: authHeader() });
      if (res.status === 401) { setCategories([]); setLoading(false); return; }
      const data = await res.json();
      setCategories(Array.isArray(data.categories) ? data.categories : data || []);
    } catch (err) {
      console.error('[fetchCategories]', err);
      setCategories([]);
    }
    setLoading(false);
  }, []);

  useEffect(() => { fetchCategories(); }, [fetchCategories]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      const user = parsed?.user || {};
      setRole(Number(user.role) || (user.isAdmin ? 2 : 3));
    } catch { setRole(3); }
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    setSaving(true);
    try {
      const res = await fetch('/api/service-categories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify({ name: newName.trim(), position }),
      });
      const data = await res.json();
      if (data?.success) {
        showToast('Category added.');
        setNewName('');
        await fetchCategories();
      } else {
        showToast(data.error || data.message || 'Failed to add.', 'error');
      }
    } catch { showToast('Failed to add.', 'error'); }
    setSaving(false);
  };

  const handleEdit = async (id) => {
    if (!editName.trim()) return;
    try {
      const res = await fetch(`/api/service-categories/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
       body: JSON.stringify({
  name: editName.trim(),
  position: editPosition,
}),
      });
      const data = await res.json();
      if (data.success) {
        showToast('Category updated.');
        setEditId(null);
        setEditName('');
        await fetchCategories();
      } else {
        showToast(data.error || 'Update failed.', 'error');
      }
    } catch { showToast('Update failed.', 'error'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this category?')) return;
    setDeleting(id);
    try {
      const res = await fetch(`/api/service-categories/${id}`, { method: 'DELETE', headers: authHeader() });
      const data = await res.json();
      if (data?.success) { showToast('Deleted.'); await fetchCategories(); }
      else showToast(data.error || data.message || 'Delete failed.', 'error');
    } catch { showToast('Delete failed.', 'error'); }
    setDeleting(null);
  };

  const handleDownloadTemplate = async () => {
    try {
      const response = await fetch('/api/service-categories/download/template', { headers: authHeader() });
      if (!response.ok) { showToast('Failed to download template', 'error'); return; }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'ServiceCategories_Template.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      showToast('Template downloaded successfully.');
    } catch { showToast('Failed to download template.', 'error'); }
  };

  const handleUploadFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await fetch('/api/service-categories/upload/bulk', {
        method: 'POST',
        headers: authHeader(),
        body: formData,
      });
      const data = await response.json();
      if (response.ok && data.success) {
        showToast(`✓ Imported ${data.created} categories${data.duplicates > 0 ? `, ${data.duplicates} duplicates skipped` : ''}`);
        await fetchCategories();
      } else {
        showToast(data.error || data.message || 'Upload failed.', 'error');
      }
    } catch { showToast('Upload failed.', 'error'); }
    finally { setUploading(false); e.target.value = ''; }
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
       {!isMobile && <Sidebar role={role} />}
    <div
  style={{
    flex: 1,
    height: '100vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  }}
>
<div
  style={{
    position: 'sticky',
    top: 0,
    zIndex: 100,
    padding: '10px',
    borderBottom: '1px solid #e2e8f0'
  }}
>
        <h2 style={{ marginTop: 0, fontSize: 22, fontWeight: 700 }}>Service Category Master</h2>

        {/* Toast */}
        {toast && (
          <div style={{
            padding: '10px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14, fontWeight: 500,
            background: toast.type === 'success' ? '#ecfeff' : '#fef2f2',
            color: toast.type === 'success' ? '#0e7490' : '#dc2626',
            border: `1px solid ${toast.type === 'success' ? '#a5f3fc' : '#fecaca'}`,
          }}>
            {toast.msg}
          </div>
        )}

        {/* Top bar: Add form + Excel buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>

          {/* Add form */}
          <form onSubmit={handleAdd} style={{ display: 'flex', gap: 10, alignItems: 'flex-end' }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 4 }}>
                Category Name <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                value={newName}
                onChange={e => setNewName(e.target.value)}
                placeholder="e.g. Plumber, Electrician"
                style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 14, width: 240, boxSizing: 'border-box' }}
              />
            </div>
           <input
  type="number"
  min="1"
  value={editPosition}
  onChange={(e) => setEditPosition(Number(e.target.value))}
  style={{
    width: 70,
    padding: "6px",
    border: "1px solid #cbd5e1",
    borderRadius: 6,
  }}
/>
            <button
              type="submit"
              disabled={saving}
              style={{ padding: '8px 20px', borderRadius: 6, backgroundColor: '#0ea5e9', color: '#fff', border: 'none', cursor: saving ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: 14, height: 38, whiteSpace: 'nowrap' }}
            >
              {saving ? 'Adding…' : '+ Add'}
            </button>
          </form>

          {/* Excel buttons */}
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              onClick={handleDownloadTemplate}
              style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', borderRadius: 6, backgroundColor: '#0ea5e9', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
            >
              <i className="fa-solid fa-download" /> Download Template
            </button>

            <label style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', borderRadius: 6, backgroundColor: uploading ? '#86efac' : '#22c55e', color: '#fff', cursor: uploading ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: 13 }}>
              <i className={`fa-solid ${uploading ? 'fa-circle-notch fa-spin' : 'fa-upload'}`} />
              {uploading ? 'Uploading…' : 'Upload Excel'}
              <input type="file" accept=".xlsx,.xls,.csv" onChange={handleUploadFile} disabled={uploading} style={{ display: 'none' }} />
            </label>
          </div>
        </div>
        </div>
 
        {/* Table */}
       <div
  style={{
    flex: 1,
    overflow: 'auto',
    padding: '24px',
    background: '#f8fafc'
  }}
>
  <div
    style={{
      backgroundColor: '#fff',
      borderRadius: 12,
      border: '1px solid #e2e8f0',
      overflow: 'hidden',
      boxShadow: '0 2px 8px #0001',
      marginBottom: 30,
    }}
  >
          <div style={{ overflowX: 'auto' }}>
            <table className='tablcss' style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead>
                <tr style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155', width: 40 }}>#</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#334155' }}>Category Name</th>
                  <th style={{ padding: '12px 16px', textAlign: 'center', fontWeight: 600, color: '#334155', width: 160 }}>Actions</th>
                <th
  style={{
    padding: "12px 16px",
    textAlign: "center",
    fontWeight: 600,
    color: "#334155",
    width: 100,
  }}
>
  Position
</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={3} style={{ padding: 32, textAlign: 'center', color: '#64748b' }}>
                      <i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: 8 }} />Loading…
                    </td>
                  </tr>
                ) : categories.length === 0 ? (
                  <tr>
                    <td colSpan={3} style={{ padding: 32, textAlign: 'center', color: '#64748b' }}>
                      No categories yet. Add one above.
                    </td>
                  </tr>
                ) : categories.map((c, i) => (
                  <tr
                    key={c.id || c._id}
                    style={{ borderBottom: '1px solid #e2e8f0', backgroundColor: '#fff', transition: 'background 0.15s' }}
                    onMouseOver={e => e.currentTarget.style.backgroundColor = '#f8fafc'}
                    onMouseOut={e => e.currentTarget.style.backgroundColor = '#fff'}
                  >
                    <td style={{ padding: '12px 16px', color: '#94a3b8' }}>{i + 1}</td>

                    <td style={{ padding: '12px 16px' }}>
                      {editId === (c.id || c._id) ? (
                        <input
                          value={editName}
                          onChange={e => setEditName(e.target.value)}
                          style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13, width: '100%' }}
                        />
                      ) : (
                        <strong>{c.name || c.category || c}</strong>
                      )}
                    </td>

                    <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                      {editId === (c.id || c._id) ? (
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                          <button
                            onClick={() => handleEdit(c.id || c._id)}
                            style={{ padding: '5px 14px', borderRadius: 6, backgroundColor: '#22c55e', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}
                          >
                            Save
                          </button>
                          <button
                            onClick={() => { setEditId(null); setEditName(''); }}
                            style={{ padding: '5px 14px', borderRadius: 6, backgroundColor: '#94a3b8', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                          <button
                           onClick={() => {
  setEditId(c.id);
  setEditName(c.name);
  setEditPosition(c.position);
}}
                            style={{ padding: '5px 14px', borderRadius: 6, backgroundColor: '#0ea5e9', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}
                          >
                            <i className="fa-solid fa-pen" style={{ marginRight: 4 }} />Edit
                          </button>
                          <button
                            onClick={() => handleDelete(c.id || c._id)}
                            disabled={deleting === (c.id || c._id)}
                            style={{ padding: '5px 14px', borderRadius: 6, backgroundColor: deleting === (c.id || c._id) ? '#cbd5e1' : '#ef4444', color: '#fff', border: 'none', cursor: deleting === (c.id || c._id) ? 'not-allowed' : 'pointer', fontSize: 12, fontWeight: 600 }}
                          >
                            <i className="fa-solid fa-trash" style={{ marginRight: 4 }} />
                            {deleting === (c.id || c._id) ? 'Deleting…' : 'Delete'}
                          </button>
                        </div>
                      )}
                    </td>
                    <td
  style={{
    padding: "12px 16px",
    textAlign: "center",
  }}
>
  {c.position}
</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
</div>
      </div>
       {isMobile && <MobileBottomNav activeTab={activeTab} setActiveTab={setActiveTab} />}

    </div>
  );
}